import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/apply',
    name: 'Apply',
    component: () => import('../views/apply.vue')
  },
  {
    path: '/fcbscarbon',
    name: 'FCBSCarbon',
    component: () => import('../views/carbon.vue')
  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/404.vue')
  }
]

let router =new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.name;
  next();
});

export default router
